// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "flights-bKkNG";
var _3 = "flight-2OYpJ";
var _4 = "flight_noMargin-1vUlp";
var _5 = "wrapper__button-2B4Y6";
var _6 = "button-PFtdR";
var _7 = "button__icon-UthSU";
var _8 = "button__icon_active-3_jn1";
var _9 = "content-3OfA8";
var _a = "planeIcon-3qUQN";
export { _1 as "__esModule", _2 as "flights", _3 as "flight", _4 as "flight_noMargin", _5 as "wrapper__button", _6 as "button", _7 as "button__icon", _8 as "button__icon_active", _9 as "content", _a as "planeIcon" }
export default { "__esModule": _1, "flights": _2, "flight": _3, "flight_noMargin": _4, "wrapper__button": _5, "button": _6, "button__icon": _7, "button__icon_active": _8, "content": _9, "planeIcon": _a }
